import React, { useState } from "react";

const StoryTelling = () => {
  const [isContinuePressed, setIsContinuePressed] = useState(false);

  return (
    <>
      <div className="homepage-about-goals">
        <div className="homepage-about-goal fade-in">
          <h3>1. יותר הזדמנויות להכיר</h3>

          <p>
            להביא התאמות לחברי האתר באופן שוויוני ומכבד, ללא תלות במעגל החברתי
            שלהם.
          </p>
        </div>

        <div className="homepage-about-goal fade-in">
          <h3>2. טכנולוגיה שפועלת בשבילך</h3>

          <p>
            ללמוד את ההעדפות והסגנון שלך ולהציע התאמות אישיות וממוקדות בעזרת
            אלגוריתם חכם.
          </p>
        </div>

        <div className="homepage-about-goal fade-in">
          <h3>3. ההצעות מגיעות אליך</h3>

          <p>
            בלי לגלול בין מאות פרופילים ובלי להפוך לכרטיס שפתוח בפני כולם. כי
            מגיע לך שיגיעו עד אליך.
          </p>
        </div>
      </div>

      <div className="homepage-founder fade-in">
        <div className="homepage-founder-image">
          <div className="MichalI"></div>
        </div>

        <div className="homepage-founder-content">
          <h3 className="h-nomargin-bold">כמה מילים מהמייסדת</h3>

          <p>
            הקמתי את דאבל מתוך היכרות אישית עם עולם הדייטינג, ומתוך רצון ליצור
            דרך אחרת, נעימה יותר, להכיר.
          </p>

          <p>
            גם אני חיפשתי זוגיות במשך תקופה לא קצרה. לא התחברתי לגלילה האינסופית
            בין מאות פרופילים, נמאס לי מהתחושה של לזהות אנשים ברחוב כי ראיתי
            אותם קודם באפליקציה, ובינינו – לא תמיד נעים לפנות שוב ושוב לחברים
            ולבקש שיחשבו על רעיון.
          </p>

          <button
            type="button"
            className="signup-homepage"
            style={{
              width: "180px",
              height: "42px",
              lineHeight: "42px",
              fontSize: "16px",
              padding: "0",
              marginTop: "12px",
              animation: "none",
              textShadow: "none",
            }}
            onClick={() => setIsContinuePressed(!isContinuePressed)}
          >
            {isContinuePressed ? "הצג פחות" : "לסיפור המלא"}
          </button>

          {isContinuePressed && (
            <div className="homepage-about-expanded fade-in">
              <p>
                יום אחד חברה הציעה לי לפנות לחברה אחרת ולשאול אם יש לה מישהו
                להכיר לי. פניתי, אבל לא היה לה.
              </p>

              <p>
                <strong>
                  באותו רגע בדיוק הבנתי מה חסר לי – חבר שדכן וירטואלי.
                </strong>
              </p>

              <p>
                חבר שמכיר אותי באמת, מבין מה חשוב לי, חושב בשבילי ומציע לי
                התאמות מדויקות מתוך המאגר שלו.
              </p>

              <p>
                לקחתי את הידע שלי משני תארים במתמטיקה ואת הניסיון שלי בפיתוח
                תוכנה, והפכתי את הרעיון הזה למציאות – אתר היכרויות שפועל כמו חבר
                שדכן וירטואלי, ומטרתו לעזור לאנשים למצוא זוגיות בצורה מכבדת,
                אישית ודיסקרטית.
              </p>

              <p>
                גם היום, לפני כל פיצ׳ר חדש שאנחנו מפתחים, אנחנו שואלים את עצמנו
                שאלה אחת:
              </p>

              <p>
                <strong>איך חבר שדכן היה עוזר לך עכשיו?</strong>
              </p>

              <p>
                זו הסיבה שדאבל לא חושף אותך בפני מאות אנשים, אלא לומד אותך, חושב
                בשבילך ומציע לך התאמות אישיות ומדויקות.
              </p>

              <p>
                <strong>מוזמנים להצטרף. תנסו, מקסימום תינשאו. 😉</strong>
              </p>

              <a
                href="/signup"
                className="signup-homepage"
                style={{
                  display: "inline-block",
                  width: "220px",
                  height: "42px",
                  lineHeight: "42px",
                  fontSize: "16px",
                  padding: "0",
                  marginTop: "8px",
                  animation: "none",
                  textShadow: "none",
                  textDecoration: "none",
                  textAlign: "center",
                }}
              >
                אתם כבר כאן – הירשמו
              </a>
            </div>
          )}
        </div>
      </div>

      <div className="homepage-team fade-in">
        <h3 className="h-nomargin-bold">האנשים שמאחורי דאבל</h3>

        <div className="faceline homepage-team-row">
          <div>
            <div className="TomerC faceItem"></div>
            <div>תומר כהן</div>
            <div>מתכנת ראשי</div>
          </div>

          <div>
            <div className="RomiM faceItem"></div>
            <div>רומי מלחי</div>
            <div>ארט דיירקטור</div>
          </div>

          <div>
            <div className="MosheI faceItem"></div>
            <div>מוישי יזרלביץ</div>
            <div>מתכנת AI</div>
          </div>

          <div>
            <div className="NadavKHomepage faceItem"></div>
            <div>נדב קוקורייב</div>
            <div>פיתוח עסקי</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoryTelling;

/*import React, { useState } from "react";

const StoryTelling = () => {
  const [isContinuePressed, setIsContinuePressed] = useState(false);

  return (
    <div
      className="contactUsHelper tellAboutUsSection fade-in"
      style={{ borderBottom: "0px", animationDelay: "1.2s" }}
    >
      <b className="fade-in" style={{ animationDelay: "1.4s" }}>
        האתר הוקם למען 3 מטרות עיקריות:
      </b>
      <br />
      <div className="fade-in" style={{ animationDelay: "1.6s" }}>
        1. <b>להביא התאמות לחברי האתר</b> באופן כמה שיותר שיוויוני ומכבד, ללא
        קשר לסביבה החברתית שלהם היום.
      </div>
      <br />
      <div className="fade-in" style={{ animationDelay: "1.8s" }}>
        2. לנצל את <b>הטכנולוגיה</b>, הכישורים, <b>והחוויה</b> שלנו ולהביא
        התאמות ממוקדות אליך ובסגנון שלך, שבעזרת ה' יובילו
        <b> לקשר יציב ואף לחתונה.</b>
      </div>
      <br />
      <div className="fade-in" style={{ animationDelay: "2s" }}>
        3. להביא את ההצעות אליך, <b>כי מגיע לך. יגיע עד אליך.</b>
      </div>
      <br />
      <b className="fade-in" style={{ animationDelay: "2.2s" }}>
        דאבל הכרויות הוא{" "}
        <u
          className="cursor"
          onClick={() => setIsContinuePressed(!isContinuePressed)}
        >
          {isContinuePressed ? "הצג פחות" : "להמשך קריאה"}
        </u>
      </b>
      <div
        className={`fade-in ${isContinuePressed ? "" : "invisible"}`}
        style={{ animationDelay: "1.2s" }}
      >
        <br />
        <b>השדכן הוירטואלי האולטימטיבי. הוא כמו חבר נאמן ורגיש.</b>
        <br />
        דאבל מבין ומעריך את החשיבות והיופי שבמערכות יחסים.
        <br />
        השם דאבל מייצג את הרעיון הזוגי ואת המציאות החדשה שתזכו בה במציאת אהבת
        אמת ובבניית בית בישראל, ומציע דרך נוספת בתהליך שבסופו תמצאו התאמה זוגית
        ואמיתית.
        <br />
        <br />
        כמומחים בתחום השידוכים, אנו מחויבים למציאת זוגיות למשתמשים שלנו
        <b> תוך שמירה על פרטיותם. </b> אנו מספקים חוויה מותאמת אישית ונוחה.
        <br />
        האתר שלנו פונה לקהל השמרני: (דתי, חרדי, דתלשי) שכמה למערכת יחסים
        משמעותית.
        <br />
        <b>כי טובים השניים מן האחד!</b>
        <br />
        אחרי שתירשמו לדאבל,
        <b> תיצרו פרופיל אישי, תגדירו את הצ'ק ליסט שלכם להתאמה </b>
        המושלמת. דאבל ייכנס לפעולה, יחפש וימצא עבורכן.ם – התאמה! (בעז"ה)
        <br />
        <br />
        וכעת, נעבור לדבר המייסדת ;) :
        <br />
        "הי אני מיכל, בעלת תואר ראשון במתמטיקה ותואר שני במתמטיקה וכלכלה, עבדתי
        בתחום ההיי טק הרבה שנים, ודתיה.
        <br />
        <b> אני מכירה את תחום הדייטינג </b>
        מהחוויה האישית שלי ושל חברים שלי. היה חסר לי אתר שהוא שדכן וירטואלי -
        כמו חבר טוב שלומד אותי ומחפש לי התאמה, בלי שאני הופכת לכרטיס שכולם
        יכולים לראות, ובלי שאני צריכה להיכנס ולחפש לי,
        <b> ובלי החוסר נעימות </b>
        לפנות לחברים אם יש להם רעיון.
        <br />
        מתוך כך החלטתי להקים סטארטאפ משלי בתחום הדייטינג.
        <br />
        אני עובדת על האתר כבר 3 שנים.
        <br />
        מאחר ואני מתכנתת ומכירה את התחום, ויודעת מזה לכתוב
        <b> אלגוריתם מדויק</b>
        . כתבתי אתר עם אלגוריתם מאוד מדויק ופשוט לתחום הדייטינג, שהוא הרבה יותר
        ידידותי, פשוט, חכם.
        <br />
        אתר שמניב תוצאות מדויקות ונותן את החוויה בתחום הדייטים
        <b> בצורה אחרת לגמרי, </b>
        מתוך הנישה החברתית המדויקת של כל נרשם באתר. אני מכירה מקרוב את החברה
        הדתית, החרדית, והדתלשית. (עבור היחודיות של החברה החרדית - עשיתי חקר שוק
        נוסף ודיוקים בהתאם.)
        <br />
        האתר כל הזמן משתדרג לפי החוויה של המשתמשים, ומדייקים אותו עוד ועוד."
        <br />
        הצטרפו אלינו למסע למציאת ההתאמה המושלמת – בדאבל!
        <br />
      </div>
      <br />
      <b className="fade-in" style={{ animationDelay: "2.4s" }}>
        <u>צוות האתר</u>
      </b>
      <div className="fade-in" style={{ animationDelay: "2.6s" }}>
        <div className="MichalI"></div>
        <div>מיכל יזרלביץ</div>
        <div style={{ marginTop: "-4px" }}>מייסדת</div>
      </div>
      <br />
      <div className="faceline fade-in" style={{ animationDelay: "2.8s" }}>
        <div>
          <div className="TomerC faceItem"></div>
          <div>תומר כהן</div>
          <div style={{ marginTop: "-4px" }}> מתכנת ראשי </div>
        </div>
        <div>
          <div className="RomiM faceItem"></div>
          <div> רומי מלחי</div>
          <div style={{ marginTop: "-4px" }}>ארט דיירקטור</div>
        </div>
      </div>
      <div className="faceline fade-in" style={{ animationDelay: "2.8s" }}>
        <div>
          <div className="MosheI faceItem"></div>
          <div> מוישי יזרלביץ</div>
          <div style={{ marginTop: "-4px" }}> מתכנת AI</div>
        </div>
        <div>
          <div className="NadavKHomepage faceItem"></div>
          <div>נדב קוקורייב</div>
          <div style={{ marginTop: "-4px" }}> פיתוח עסקי</div>
        </div>
      </div>
    </div>
  );
};

export default StoryTelling;
*/
